import { render } from "./modalViewWechat.vue?vue&type=template&id=7f7bbd74"
import script from "./modalViewWechat.vue?vue&type=script&lang=js"
export * from "./modalViewWechat.vue?vue&type=script&lang=js"

import "./modalViewWechat.vue?vue&type=style&index=0&id=7f7bbd74&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__